import {
  calculateColumnWidth,
  mapColumnTypes,
  selectColumnFactory,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import * as yup from "yup";
import {
  DESTINATION_TYPES,
  RULE_CONDITIONS,
  RULE_CONTROLS,
} from "@/react/features/support-tools/extensions/constants";
import { DestinationEditableCell } from "./cells/DestinationEditableCell";
import { DestinationCell } from "./cells/DestinationCell";
import DestinationColumnSetter from "@/react/features/support-tools/extensions/forwarding-rules/cells/DestinationColumnSetter";

const columnsForRule = (rule) => {
  return [
    {
      ...getColumnDef(
        yup.reach(
          schema,
          `forwardingRules.${rule}.destination.destinationType`
        ),
        `${rule} - Destination Type`
      ),
      type: TYPES.SELECT,
      options: DESTINATION_TYPES,
      editable: true,
    },
    {
      ...getColumnDef(
        yup.reach(schema, `forwardingRules.${rule}.destination.destination`),
        `${rule} - Destination`
      ),
      cell: DestinationCell(rule),
      editableCell: DestinationEditableCell(rule),
      columnSetter: DestinationColumnSetter(rule),
      editable: true,
    },
    // Add No Answer Fwd Delay column only if rule is NO_ANSWER
    ...(rule === RULE_CONDITIONS.NO_ANSWER
      ? [
          {
            ...getColumnDef(
              yup.reach(schema, `forwardingRules.${rule}.noAnswerForwardDelay`),
              `${rule} - No Answer Fwd Delay`
            ),
            type: TYPES.STRING,
            editable: true,
          },
        ]
      : []),
    {
      ...getColumnDef(
        yup.reach(schema, `forwardingRules.${rule}.priority`),
        `${rule} - Priority`
      ),
      type: TYPES.STRING,
    },
    {
      ...getColumnDef(
        yup.reach(schema, `forwardingRules.${rule}.ruleControl`),
        `${rule} - Rule Control`
      ),
      type: TYPES.SELECT,
      options: RULE_CONTROLS,
      editable: true,
    },
  ];
};

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(
          yup.reach(schema, "extension.subscriptionId"),
          "Subscription ID"
        ),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "extension.extensionNumber"),
          "Extension"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "extension.callerIdFirstName"),
          "First Name"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "extension.callerIdLastName"),
          "Last Name"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "extension.primaryDID"),
          "Primary Did"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "extension.serviceType"),
          "Service Type"
        ),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(yup.reach(schema, "extension.branch.name"), "Branch"),
        type: TYPES.STRING,
      },
      ...columnsForRule(RULE_CONDITIONS.BUSY),
      ...columnsForRule(RULE_CONDITIONS.NO_ANSWER),
      ...columnsForRule(RULE_CONDITIONS.OUTAGE),
    ].map(mapColumnTypes)
  );

export default columnDefinition;
